var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_wrap",style:({
    'width': _vm.size + 'px',
    'height': _vm.size + 'px',
    'border-width': _vm.borderSize + 'px',
    'border-color': _vm.borderColor
})})
}
var staticRenderFns = []

export { render, staticRenderFns }